var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 2.44772 2.44772 2 3 2H11.9958C12.5481 2 12.9958 2.44772 12.9958 3C12.9958 3.55228 12.5481 4 11.9958 4H4V20H12C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22H3C2.44772 22 2 21.5523 2 21V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7929 6.79289C16.1834 6.40237 16.8166 6.40237 17.2071 6.79289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L17.2071 17.2071C16.8166 17.5976 16.1834 17.5976 15.7929 17.2071C15.4024 16.8166 15.4024 16.1834 15.7929 15.7929L19.5858 12L15.7929 8.20711C15.4024 7.81658 15.4024 7.18342 15.7929 6.79289Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.9958C7 11.4436 7.44772 10.9958 8 10.9958H21C21.5523 10.9958 22 11.4436 22 11.9958C22 12.5481 21.5523 12.9958 21 12.9958H8C7.44772 12.9958 7 12.5481 7 11.9958Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9e278183a6e5a09761401b1e997bd856.svg";
export { ForwardRef as ReactComponent };